/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `BiankaScript, cursive;`,
  subHeading: `Philosopher, cursive;`,
  body: `'Philosopher', sans-serif;`,
  name: `BiankaScript, cursive;`,
  fullName: `'Philosopher', sans-serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    textAlign: 'center',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    textTransform: 'uppercase',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    textAlign: 'center',
    textTransform: 'none',
  },
};

export const PRIMARY_BUTTON_PROPS = {
  ...TEXT_PROPS.body,
  fontSize: 'calc(var(--chakra-fontSizes-body) - 2px)',
  size: 'sm',
  bgColor: 'bgSecondary',
  color: 'btnMainColor',
  _active: { opacity: '0.9' },
  _hover: { opacity: '0.7' },
};

export const SECONDARY_BUTTON_PROPS = {
  ...PRIMARY_BUTTON_PROPS,
  bgColor: 'bgPrimary',
  color: 'mainColorText',
};
